module.exports = __webpack_public_path__ + "static/media/m-penguin-igloo.a751dc14.png";